import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './loader';

/**
 * RoleProtectedRoute - restricts access to users whose role is in allowedRoles.
 * Used as a layout route: wraps a group of <Route> children via <Outlet />.
 *
 * If not authenticated → redirects to /login
 * If authenticated but role not allowed → redirects to the user's natural home
 */
const RoleProtectedRoute = ({ allowedRoles }) => {
    const { isAuthenticated, isLoading, role } = useAuth();
    const context = useOutletContext();

    if (isLoading) {
        return <Loader />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(role)) {
        // Redirect user to their appropriate home rather than a 403 error
        const homePath = role === 'candidate' ? '/events' : '/dashboard';
        return <Navigate to={homePath} replace />;
    }

    return <Outlet context={context} />;
};

RoleProtectedRoute.propTypes = {
    allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default RoleProtectedRoute;
